import React from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

export default function Loading() {
  const LoadingRow = () => (
    <div className='h-[30px] w-[290px] flex flex-row px-4 items-center gap-x-2'>
      <Skeleton containerClassName='w-5 h-5' circle />
      <div className='h-5 w-full flex flex-row gap-x-1'>
        <Skeleton containerClassName='w-32' />
        <Skeleton containerClassName='w-24' />
      </div>
    </div>
  );
  return <Skeleton wrapper={LoadingRow} count={5} />;
}
